import { ReactNode } from "react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";

interface NeumorphicLogoBoxProps {
  children: ReactNode;
  className?: string;
}

const NeumorphicLogoBox = ({ children, className = "" }: NeumorphicLogoBoxProps) => {
  let theme = "light";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }

  const getStyles = () => {
    if (theme === "dark") {
      return "bg-[#0a0a0a] shadow-[16px_16px_32px_#000000,-16px_-16px_32px_#0d0d0d]";
    } else {
      return "bg-white";
    }
  };

  return (
    <div className={cn(
      "rounded-2xl transition-all duration-300",
      getStyles(),
      className
    )}>
      {children}
    </div>
  );
};

export default NeumorphicLogoBox;
